// src/services/collectionApi.js
// Servicio para manejar operaciones relacionadas con colecciones (catálogos)

import { dotoniwoofApi } from '../api/dotoniwooApi';

// Los headers de autenticación se agregan automáticamente por el interceptor de axios

/**
 * Lista todas las colecciones
 * @returns {Promise<Object>} Lista de colecciones
 */
export const getCollections = async () => {
  try {
    const response = await dotoniwoofApi.get('/collection.php');
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener colecciones:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene una colección por ID
 * @param {number} collectionId - ID de la colección
 * @returns {Promise<Object>} Datos de la colección
 */
export const getCollectionById = async (collectionId) => {
  try {
    const response = await dotoniwoofApi.get(`/collection.php/${collectionId}`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene productos de una colección
 * @param {number} collectionId - ID de la colección
 * @returns {Promise<Object>} Lista de productos de la colección
 */
export const getCollectionProducts = async (collectionId) => {
  try {
    const response = await dotoniwoofApi.get(`/collection.php/${collectionId}/products`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener productos de colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crea una nueva colección
 * @param {Object} collectionData - Datos de la colección
 * @returns {Promise<Object>} Respuesta de la API
 */
export const createCollection = async (collectionData) => {
  try {
    console.log('Enviando datos de la colección:', collectionData);
    
    const response = await dotoniwoofApi.post(
      '/collection.php',
      collectionData
    );
    
    console.log('Respuesta del servidor:', response.data);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualiza una colección existente
 * @param {number} collectionId - ID de la colección
 * @param {Object} collectionData - Nuevos datos de la colección
 * @returns {Promise<Object>} Respuesta de la API
 */
export const updateCollection = async (collectionId, collectionData) => {
  try {
    console.log('Actualizando colección:', collectionId, collectionData);
    
    const response = await dotoniwoofApi.put(
      `/collection.php/${collectionId}`,
      collectionData
    );
    
    console.log('Respuesta del servidor:', response.data);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Elimina una colección
 * @param {number} collectionId - ID de la colección
 * @returns {Promise<Object>} Respuesta de la API
 */
export const deleteCollection = async (collectionId) => {
  try {
    const response = await dotoniwoofApi.delete(
      `/collection.php/${collectionId}`
    );
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
